import * as React from 'react';
import classnames from 'classnames';

import ActionLink from 'components/buttons/action-link/ActionLink';

import { __t, applyTranslations } from 'utils/language';

import './managed-by-tag.scss';

import type { BrandProfileManagedBy } from 'types';

applyTranslations(require('./managed-by-tag.i18n.json'));

type Props = {
  managedByBrand: BrandProfileManagedBy,
  className: string
};

class ManagedByTag extends React.PureComponent<Props> {
  static defaultProps = {
    className: ''
  };

  render(): React.ReactNode {
    const { className, managedByBrand } = this.props;

    if (!managedByBrand || !managedByBrand.name) {
      return null;
    }

    const clasess = classnames({
      'managed-by-tag': true,
      [className]: Boolean(className)
    });

    return (
      <div className={clasess}>
        <span className="managed-by-tag__label">
          {__t('managed_by_tag.managed_by')}
        </span>
        {
          managedByBrand.profileId ? (
            <ActionLink
              decoration="none"
              inline
              size="medium"
              color="light"
              link={`/brand/profiles/${managedByBrand.profileId}`}
              className="managed-by-tag__link"
            >
              {managedByBrand.name}
            </ActionLink>
          ) :
            managedByBrand.name
        }
      </div>
    );
  }
}

export default ManagedByTag;
